import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import { VerifyEmailPage } from "./components/VerifyEmailPage";
import { VerifyEmailPrompt } from "./components/VerifyEmailPrompt";
import { AllegroConnectPage } from "./components/AllegroConnectPage";
import { MainAppContent, DefaultPrivateNotFound } from "./MainAppContent";
import ForgotPasswordForm from "./components/ForgotPasswordForm";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import { APP_ROUTE_DEFINITIONS, ROUTE_REDIRECTS } from "./app/routesConfig";
import { PageScaffold } from "./app/PageScaffold";

const App = () => {
  const renderPrivateRoutes = () =>
    APP_ROUTE_DEFINITIONS.map(({ path, Component, layout, wrapWithScaffold = true }) => {
      const pageContent = Component ? <Component /> : <DefaultPrivateNotFound />;
      const element =
        wrapWithScaffold === false ? pageContent : <PageScaffold layout={layout}>{pageContent}</PageScaffold>;

      return <Route key={path} path={path} element={element} />;
    });

  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="min-h-screen bg-transparent text-gray-900 backdrop-blur-sm">
          <Routes>
            <Route path="/verify-email" element={<VerifyEmailPrompt />} />
            <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
            <Route path="/allegro-connect" element={<AllegroConnectPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordForm />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route element={<MainAppContent />}>
              {Object.entries(ROUTE_REDIRECTS).map(([from, to]) => (
                <Route key={`${from}->${to}`} path={from} element={<Navigate to={to} replace />} />
              ))}
              {renderPrivateRoutes()}
              <Route path="*" element={<DefaultPrivateNotFound />} />
            </Route>
          </Routes>
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
